<p-accordionTab>
    <p-header>
        <div class="ui-helper-clearfix">
            <div class="left">
                <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Global
                    Configuration (AT+GTCFG)</span>
            </div>
        </div>
    </p-header>

    <div class="ui-g">
        <div class="ui-g-12">
            <p-accordionTab [selected]="true">
                <p-header>
                    <div class="ui-helper-clearfix">
                        <div class="left">
                            <span class="ui-panel-title"
                                style="font-size:16px;display:inline-block;margin-top:2px">Device Working Status
                                Settings</span>
                        </div>
                    </div>
                </p-header>

                <div class="row align-items-center">

                    <div class="col row dvcFields">
                        <div class="col lblStyle">
                            <form-input fieldName="Power Saving Mode">
                            </form-input>
                        </div>
                        <div class="col">
                            <p-dropdown [options]="powerOptions" [(ngModel)]="globalParameters.powerMode"
                                [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col lblStyle">
                            <form-input fieldName="Wakeup Hour Interval">
                            </form-input>
                        </div>
                        <div class="col">
                            <div class="ui-inputgroup">
                                <p-spinner size="5" step="1" [(ngModel)]="globalParameters.wakeupHourInterval" [min]="1"
                                    [max]="720"></p-spinner>
                                <span class="ui-inputgroup-addon">1~720</span>
                                <span class="ui-inputgroup-addon">h</span>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col lblStyle">
                            <form-input fieldName="Sensor Wakeup Debounce">
                            </form-input>
                        </div>
                        <div class="col">
                            <div class="ui-inputgroup">
                                <p-spinner size="5" step="1" [(ngModel)]="globalParameters.sensorWakeupDebounce" [min]="0"
                                    [max]="60"></p-spinner>
                                <span class="ui-inputgroup-addon">0~60</span>
                                <span class="ui-inputgroup-addon">sec</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col lblStyle">
                            <form-input fieldName="Work Time per Wakeup">
                            </form-input>
                        </div>
                        <div class="col">
                            <div class="ui-inputgroup">
                                <p-spinner size="5" step="1" [(ngModel)]="globalParameters.workTimeWakeup" [min]="1"
                                    [max]="60"></p-spinner>
                                <span class="ui-inputgroup-addon">1~60</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col lblStyle">
                            <form-input fieldName="Backup Battery Charge Mode">
                            </form-input>
                        </div>
                        <div class="col">
                            <p-dropdown [options]="backupBatteryChargeOptions" [(ngModel)]="globalParameters.batteryChargeMode"
                                [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
                        </div>
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col lblStyle">
                            <form-input fieldName="LED On">
                            </form-input>
                        </div>
                        <div class="col">
                            <p-dropdown [options]="ledOnOptions" [(ngModel)]="globalParameters.ledON"
                                [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
                        </div>
                    </div>
                </div>
            </p-accordionTab>
        </div>

        <div class="ui-g-12">
            <p-accordionTab [selected]="true">
                <p-header>
                    <div class="ui-helper-clearfix">
                        <div class="left">
                            <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Mask
                                Settings</span>
                        </div>
                    </div>
                </p-header>

                <div class="row align-items-center">
                    <form-input fieldName="Composition Mask"></form-input>
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="Speed" [(ngModel)]="globalParameters.speed">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="Mileage" [(ngModel)]="globalParameters.mileage">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="Azimuth" [(ngModel)]="globalParameters.azimuth">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="Send Time" [(ngModel)]="globalParameters.sendTime">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="Altitude" [(ngModel)]="globalParameters.altitude">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="Device Name" [(ngModel)]="globalParameters.deviceName">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="Cell Info Network Data" [(ngModel)]="globalParameters.gsmTowerData">
                            </p-checkbox>
                        </div>
                        <div class="col">
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <form-input fieldName="Event Mask"></form-input>
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTSTC" [(ngModel)]="globalParameters.eventMaskRESPGTSTC">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTSTT" [(ngModel)]="globalParameters.eventMaskRESPGTSTT">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTPDP" [(ngModel)]="globalParameters.eventMaskRESPGTPDP">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTRTL" [(ngModel)]="globalParameters.eventMaskRESPGTRTL">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTIGN/IGF/VGN/VGF" [(ngModel)]="globalParameters.eventMaskIgnitionReportRESPGTIGNRESPGTIGFRESPGTVGNRESPGTVGF">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTIGL/GTVGL" [(ngModel)]="globalParameters.eventMaskIgnitionOnOffRESPGTIGLRESPGTVGL">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTIGS" [(ngModel)]="globalParameters.eventMaskRESPGTIGS">
                            </p-checkbox>
                        </div>
                        <div class="col">
                        </div>
                    </div>       
                </div>
 
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col lblStyle">
                            <form-input fieldName="GSM Report">
                            </form-input>
                        </div>
                        <div class="col">
                            <p-dropdown [options]="gsmOptions" [(ngModel)]="globalParameters.gsmReport"
                                [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTRTL" [(ngModel)]="globalParameters.eventMaskRESPGTRTL">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTFRI/GTERI" [(ngModel)]="globalParameters.eventMaskRESPGTFRIRESPGTERI">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <form-input fieldName="IGS Composition Mask"></form-input>
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="Duration of Ignition On" [(ngModel)]="globalParameters.durationIgnitionOn">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="Ignition On Time" [(ngModel)]="globalParameters.ignitionOnTime">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="Ignition Off Time" [(ngModel)]="globalParameters.ignitionOffTime">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="Hightest Speed Point data" [(ngModel)]="globalParameters.highestSpeed">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
            </p-accordionTab>
        </div>
    </div>
</p-accordionTab>